"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var routes = {
  '/blog': {
    title: 'Blog',
    view: 'Articles',
    "public": true,
    locales: {
      az: '/az/blog',
      en: '/en/blog',
      ru: '/ru/blog'
    }
  },
  '/az/blog': {
    ref: '/blog',
    lang: 'az',
    title: 'Bloq'
  },
  '/en/blog': {
    ref: '/blog',
    lang: 'en',
    title: 'Blog'
  },
  '/ru/blog': {
    ref: '/blog',
    lang: 'ru',
    title: 'Блог'
  }
};
var _default = exports["default"] = routes;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6WyJyb3V0ZXMiLCJ0aXRsZSIsInZpZXciLCJsb2NhbGVzIiwiYXoiLCJlbiIsInJ1IiwicmVmIiwibGFuZyIsIl9kZWZhdWx0IiwiZXhwb3J0cyJdLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uLy4uLy4uL2xpYnJhcnkvc3JjL2NsaWVudC9tb2R1bGVzL0NvbnRlbnQvQXJ0aWNsZS9BcnRpY2xlUm91dGVzLmpzIl0sInNvdXJjZXNDb250ZW50IjpbImNvbnN0IHJvdXRlcyA9IHtcclxuXHQnL2Jsb2cnOiB7XHJcblx0XHR0aXRsZTogJ0Jsb2cnLFxyXG5cdFx0dmlldzogJ0FydGljbGVzJyxcclxuXHRcdHB1YmxpYzogdHJ1ZSxcclxuXHRcdGxvY2FsZXM6IHtcclxuXHRcdFx0YXo6ICcvYXovYmxvZycsXHJcblx0XHRcdGVuOiAnL2VuL2Jsb2cnLFxyXG5cdFx0XHRydTogJy9ydS9ibG9nJyxcclxuXHRcdH1cclxuXHR9LFxyXG5cdCcvYXovYmxvZyc6IHtyZWY6ICcvYmxvZycsIGxhbmc6ICdheicsIHRpdGxlOiAnQmxvcSd9LFxyXG5cdCcvZW4vYmxvZyc6IHtyZWY6ICcvYmxvZycsIGxhbmc6ICdlbicsIHRpdGxlOiAnQmxvZyd9LFxyXG5cdCcvcnUvYmxvZyc6IHtyZWY6ICcvYmxvZycsIGxhbmc6ICdydScsIHRpdGxlOiAn0JHQu9C+0LMnfSxcclxufTtcclxuXHJcbmV4cG9ydCBkZWZhdWx0IHJvdXRlcztcclxuIl0sIm1hcHBpbmdzIjoiOzs7Ozs7QUFBQSxJQUFNQSxNQUFNLEdBQUc7RUFDZCxPQUFPLEVBQUU7SUFDUkMsS0FBSyxFQUFFLE1BQU07SUFDYkMsSUFBSSxFQUFFLFVBQVU7SUFDaEIsVUFBUSxJQUFJO0lBQ1pDLE9BQU8sRUFBRTtNQUNSQyxFQUFFLEVBQUUsVUFBVTtNQUNkQyxFQUFFLEVBQUUsVUFBVTtNQUNkQyxFQUFFLEVBQUU7SUFDTDtFQUNELENBQUM7RUFDRCxVQUFVLEVBQUU7SUFBQ0MsR0FBRyxFQUFFLE9BQU87SUFBRUMsSUFBSSxFQUFFLElBQUk7SUFBRVAsS0FBSyxFQUFFO0VBQU0sQ0FBQztFQUNyRCxVQUFVLEVBQUU7SUFBQ00sR0FBRyxFQUFFLE9BQU87SUFBRUMsSUFBSSxFQUFFLElBQUk7SUFBRVAsS0FBSyxFQUFFO0VBQU0sQ0FBQztFQUNyRCxVQUFVLEVBQUU7SUFBQ00sR0FBRyxFQUFFLE9BQU87SUFBRUMsSUFBSSxFQUFFLElBQUk7SUFBRVAsS0FBSyxFQUFFO0VBQU07QUFDckQsQ0FBQztBQUFDLElBQUFRLFFBQUEsR0FBQUMsT0FBQSxjQUVhVixNQUFNIn0=